import { SatCreditsRecurringTransaction } from '@/components/transactions/SatCreditsRecurringTransaction';

export const SatCreditsEditRecurringPage = () => <SatCreditsRecurringTransaction />;
